// import React from 'react';
// import TextField from '@material-ui/core/TextField';
// import {
//     fade,
//     ThemeProvider,
//     withStyles,
//     makeStyles,
//     createMuiTheme,
// } from '@material-ui/core/styles';
// const useStyles = makeStyles((theme) => ({
//     root: {
//         '& .MuiTextField-root': {
//             margin: theme.spacing(1),
//             width: '50ch',
//         },
//     },
// }));
// const CssTextField = withStyles({
//     root: {
//         '& label': {
//             color: '#DADADA',
//         },
//         '& label.Mui-focused': {
//             color: '#DADADA',
//         },
//         '& .MuiInput-underline:after': {
//             borderBottomColor: '#EFEFEF',
//         },
//         '& .MuiInput-underline:before': {
//             borderBottomColor: '#EFEFEF',
//         },
//         '& .MuiOutlinedInput-root': {
//             '& fieldset': {
//                 borderColor: '#F5CCD7',
//             },
//             '&:hover fieldset': {
//                 borderColor: '#EFEFEF',
//             },
//             '&.Mui-focused fieldset': {
//                 borderColor: '#EFEFEF',
//             },
//         },
//     },
// })(TextField);
// export default function TextInput(props) {
//     const classes = useStyles();
//     return (
//         <div className="login-inputs">
//             <CssTextField
//                 className={classes.margin}
//                 id="standard-number"
//                 label={props.label}
//                 type={props.type}
//                 value={props.value}
//                 variant="outlined"
//                 InputLabelProps={{
//                     shrink: true,
//                 }}
//             />
//         </div>
//     )
// }
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from "next-i18next";
import styles from "./LoginInputs.module.scss";

function LoginInput(props) {
    const translate = useSelector(state => state.translate);
    const { t } = useTranslation();
    return (
        <div className={`${styles.input_validation}`}>
            <div className={`${styles.login_input_cont} password-input`}>
                {props.icon ? props.icon : ""}
                <input
                    autocomplete="off"
                    onKeyDown={(e) => props.onKeyDown(e)}
                    className={styles.login_input}
                    value={props.value}
                    type={props.type}
                    placeholder={props.placeholder}
                    onChange={(e) => {
                        let value = e.target.value;
                        props.onChange(value);

                    }}
                />
            </div>
            {!props?.valid && props?.submitted
                ? <span className={styles.error_message}>{props.value?.length === 0
                    ? t("empty_error")
                    : props?.error_message}</span>
                : null}
        </div>
    );
}
export default LoginInput;